export const ACTION_TYPES = {
    CLEAR_ALL_STATE: 'CLEAR_ALL_STATE',
};